export class RegistrationAdminDto {
    RequestId: string;
    AgentId: string;
    AdminEmail: string;
    MainTreasuryNumber: string;
    MoreInformation: string;
    Decision: number;
    IsPaymentConfirmed:boolean;  
    shippingExpirationDate: Date;
    taxCardExpirationDate:  Date;
    taxCardAppendixExpirationDate: Date;
    taxAuthorizationExpirationDate: Date;
    commercialRecordExpirationDate:Date;
    otherDocumentsExpirationDate:Date;
    DeactivtationDate:Date;
    shippingId: string;
    taxCardId:  string;
    taxCardAppendixId: string;
    taxAuthorizationId: string;
    commercialRecordId:string;
    otherDocumentsId:string;
}